"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.polyfillApp = exports.polyfillApplication = exports.getDependents = exports.getDependencies = exports.whitelistDependencies = exports.declareDep = void 0;
// polyfill the unfinished support of apps logic
var uniq_1 = __importDefault(require("lodash/uniq"));
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var directDep = {};
var reverseDep = {};
function declareDep(name, dep) {
    directDep[name] = (directDep[name] || []).concat(dep);
    reverseDep[dep] = (reverseDep[dep] || []).concat(name);
}
exports.declareDep = declareDep;
(0, cryptoassets_1.listCryptoCurrencies)(true, true).forEach(function (a) {
    if (!a.managerAppName)
        return; // no app for this currency
    var dep = (0, cryptoassets_1.findCryptoCurrencyById)(a.family);
    if (!dep || !dep.managerAppName)
        return; // no dep
    if (dep.managerAppName === a.managerAppName)
        return; // same app
    declareDep(a.managerAppName, dep.managerAppName);
    if (!a.isTestnetFor) {
        declareDep(a.managerAppName + " Test", dep.managerAppName);
    }
});
// whitelist dependencies
exports.whitelistDependencies = ["Decred", "Decred Testnet"];
// extra dependencies
[
    ["ARTIS sigma1", "Ethereum"],
    ["EnergyWebChain", "Ethereum"],
    ["kUSD", "Ethereum"],
    ["LBRY", "Bitcoin"],
    ["Ravencoin", "Bitcoin"],
    ["Resistance", "Bitcoin"],
    ["RSK Test", "Ethereum"],
    ["RSK", "Ethereum"],
    ["ThunderCore", "Ethereum"],
    ["Volta", "Ethereum"],
    ["ZenCash", "Bitcoin"],
    ["Paraswap", "Ethereum"],
    ["Lido", "Ethereum"],
    ["1inch", "Ethereum"],
    ["Aave", "Ethereum"],
    ["Compound", "Ethereum"],
    ["Opensea", "Ethereum"],
    ["StakeDAO", "Ethereum"],
    ["Yearn", "Ethereum"],
    ["RocketPool", "Ethereum"],
    ["POAP", "Ethereum"],
    ["OlympusDAO", "Ethereum"],
    ["Rarible", "Ethereum"],
    ["Ricochet", "Ethereum"],
].forEach(function (_a) {
    var _b = __read(_a, 2), name = _b[0], dep = _b[1];
    return declareDep(name, dep);
});
var getDependencies = function (appName) {
    return directDep[appName] || [];
};
exports.getDependencies = getDependencies;
var getDependents = function (appName) {
    return reverseDep[appName] || [];
};
exports.getDependents = getDependents;
var polyfillApplication = function (app) {
    var crypto = (0, cryptoassets_1.listCryptoCurrencies)(true, true).find(function (crypto) {
        return app.name.toLowerCase() === crypto.managerAppName.toLowerCase() &&
            (crypto.managerAppName !== "Ethereum" ||
                // if it's ethereum, we have a specific case that we must only allow the Ethereum app
                app.name === "Ethereum");
    });
    var o = app;
    if (crypto && !app.currencyId) {
        o = __assign(__assign({}, o), { currencyId: crypto.id });
    }
    return o;
};
exports.polyfillApplication = polyfillApplication;
var polyfillApp = function (app) {
    var dependencies = exports.whitelistDependencies.includes(app.name)
        ? []
        : app.dependencies;
    return __assign(__assign({}, app), { dependencies: (0, uniq_1["default"])(dependencies.concat((0, exports.getDependencies)(app.name))) });
};
exports.polyfillApp = polyfillApp;
//# sourceMappingURL=polyfill.js.map